* {
  box-sizing: border-box;
}

:host {
  display: block;
  max-width: 100%;
}

:host([data-is-visible]) {
  display: block;
}

.wrapper {
  padding: 2px;
}

.form-wrapper {
  min-width: 500px;
  max-width: 700px;
  width: 100%;
  height: auto;
}

.form-section {
  max-width: 700px;
  width: 100%;
  height: auto;
  display: flex;
  margin-top: var(--spacer);
  align-items: flex-start;
  flex-direction: column;
  &#recurrence-weekly-container,
  &#recurrence-monthly-container {
    margin-top: 0;
  }
  #monthly-frequency-form-field {
    margin-right: var(--spacer);
  }
  .details-container {
    padding: 0 calc(var(--spacer) + 2px) 0 calc(var(--spacer) + 2px);
    border-left: 6px solid var(--blue-layout-200-disabled);
    margin-top: calc(var(--spacer) + 2px);
  }
  .flex-group {
    display: flex;
    align-items: flex-start;
  }
  gz-form-field {
    margin-bottom: var(--spacer);
    &#between-start-form-field,
    &#between-end-form-field,
    &#monthly-frequency-form-field,
    &#monthly-frequency-day-form-field,
    &#monthly-frequency-day-number-form-field,
    &#weekly-on-form-field {
      margin-bottom: 0;
    }
    &#recurrence-form-field {
      gz-dropdown {
        margin-left: calc(var(--spacer) * 2);
      }
    }
    .flex-group {
      align-items: center;
    }
  }
  #monthly-on-labeled-content {
    gz-title {
      min-width: 250px;
      display: flex;
      align-items: center;
      min-height: 32px;
      &:after {
        content: ':';
        position: absolute;
        padding-left: calc(var(--spacer) - 6px);
      }
    }
  }
  #between-label {
    min-width: 250px;
    min-width: 250px;
    text-align: left !important;
    margin-right: 0 !important;
    &:after {
      content: ':';
      padding-left: calc(var(--spacer) - 6px);
    }
  }
  #monthly-frequency-form-field {
    gz-dropdown {
      margin-right: var(--spacer);
    }
  }
  #applies-every-weeks-form-field,
  #applies-every-months-form-field {
    margin-bottom: 0;
    gz-dropdown {
      max-width: 65px;
      margin-right: var(--spacer);
    }
  }
  #starting-with-form-field {
    gz-input {
      max-width: 195px;
    }
  }
  #between-labeled-content {
    gz-form-field {
      margin-right: var(--spacer);
    }
    gz-title {
      max-width: 50px;
      min-height: 32px;
      margin-right: var(--spacer);
      display: flex;
      align-items: center;
    }
  }
}

.subsection-title {
  color: var(--chart-300-icon-buttons);
  margin-bottom: calc(var(--spacer) * 3);
  text-transform: uppercase;
}
